import React, { useEffect } from 'react';
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom';

import './assets/sass/main.css';
import SpayFooter from './modules/public/spay_footer';
import SpayNav from './modules/public/Spay_Nav';

// Never Delete this imported script
import './assets/javascript/script';
import { authProtectedRoutes, publicRoutes, general } from './shared/infrastructure/router';
import AppRoute from './shared/infrastructure/router/routes';
import Dashboard from './screens/Dashboard/Layouts/dashboard';
import NotFoundPage from './shared/components/Common/NotFound';

import { ToastContainer } from 'react-toastify';
import { FallbackProvider } from 'react-current-page-fallback';
import 'react-toastify/dist/ReactToastify.min.css';
import SafeComponent from './shared/components/Common/SafeComponent';

const App = () => {
    // useEffect(() => {
    //     window.$crisp = [];
    //     window.CRISP_WEBSITE_ID = 'fdf333f3-300c-4545-a26f-0a4761218a19';

    //     (function () {
    //         var d = document;
    //         var s = d.createElement('script');

    //         s.src = 'https://client.crisp.chat/l.js';
    //         s.async = true;
    //         d.getElementsByTagName('head')[0].appendChild(s);
    //     })();
    // }, []);

    return (
        <div className="">
            <SafeComponent>
                <ToastContainer />
                <Router>
                    <FallbackProvider>
                        <Switch>
                            {publicRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    layout={SpayNav}
                                    footer={SpayFooter}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={false}
                                    exact={route.exact}
                                    isGeneral={undefined}
                                />
                            ))}

                            {authProtectedRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    layout={Dashboard}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={true}
                                    exact={route.exact}
                                    isGeneral={undefined}
                                    footer={undefined}
                                />
                            ))}
                            {general.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    component={route.component}
                                    key={idx}
                                    isGeneral={true}
                                    exact={route.exact}
                                    layout={undefined}
                                    isAuthProtected={undefined}
                                    footer={undefined}
                                />
                            ))}

                            {general.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    component={route.component}
                                    key={idx}
                                    isGeneral={true}
                                    layout={undefined}
                                    isAuthProtected={undefined}
                                    footer={undefined}
                                />
                            ))}
                            <Route component={NotFoundPage} />
                        </Switch>
                    </FallbackProvider>
                </Router>
            </SafeComponent>
        </div>
    );
};

export default App;
